






import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { Home } from "@/shared/route-names";
import { SamlError } from "@/employee/route-names";
import * as datadog from "@/shared/datadog";
import { useUserStore } from "@/shared/store/user";
import { useSamlStore } from "@/employee/store/saml";

@Component({
  components: {
    GenericLoadingSpinner
  }
})

export default class SamlIdp extends Vue {

  samlStore = useSamlStore();
  userStore = useUserStore();

  @Prop()
  username: string;

  @Prop()
  idToken: string;

  @Prop()
  accessToken: string;

  @Prop()
  refreshToken: string;

  mounted () {
    if (this.userStore.loggedIn) {
      this.$router.push({ name: Home });
      return;
    }

    if (this.username && this.idToken && this.accessToken && this.refreshToken) {
      const model = {
        username: this.username,
        accessToken: this.accessToken,
        idToken: this.idToken,
        refreshToken: this.refreshToken
      };

      this.samlStore.setTokens(model).catch(err => {
        this.$router.push({ name: SamlError });
      });
    } else {
      const message = "Error in SAML auth";
      datadog.log(message, { fullPath: this.$route.fullPath }, "error");
      this.$router.push({ name: SamlError });
    }
  }

  @Watch("userStore.loggedIn")
  watchLoggedIn (): void {
    if (this) {
      this.$router.push({ name: Home });
    }
  }
}
